<script>
  import { customer } from "$lib/state/customer";
  /**@type {import('$lib/types/index').MagentoCustomer | ??}*/
  let account;
  customer.subscribe(item => account = item);
</script>

<div class="button-user">
  {#if account}
    <img loading="eager" src="/images/svg/signedIn.svg" alt="User signedIn" />
  {:else}
    <img loading="eager" src="/images/svg/signout.svg" alt="User signout" />
  {/if}
</div>

<style>
  .button-user {
    width: 100%;
    height: 100%;
  }
</style>
